import React from "react";
import { Outlet } from "react-router-dom";
import * as layout from '.'

const LayoutWithHeader = () => {
    return (
        <div className="min-h-screen w-full bg-white">
            <header>
                <layout.Navbar />
            </header>
            <main>
                <Outlet />
            </main>
        </div>
    );
}

export default LayoutWithHeader